import { defineElement, html, TemplateElement, unsafeHTML } from '@webtides/element-js';
import { decodeIfEscaped } from '@/services/content-service.js';
import '../../../../src/components/@e-banking/components/e-banking-rich-text/e-banking-rich-text.js';

class EditableRichText extends TemplateElement {
    properties() {
        return {
            content: {},
        };
    }
    get decodedText() {
        return decodeIfEscaped(this.content.text);
    }

    template() {
        return html` <mb-e-banking-rich-text .text="${this.decodedText}"></mb-e-banking-rich-text> `;
    }
}

defineElement('editable-rich-text', EditableRichText);
